<template>
    <div class="tinymce-editor">
        <editor v-if="!reloading" v-model="myValue" :init="init" :disabled="disabled" @onClick="onClick"> </editor>
    </div>
</template>

<script>
import tinymce from 'tinymce/tinymce';
import Editor from '@tinymce/tinymce-vue';
import '../../public/tinymce/axupimgs'
import 'tinymce/themes/silver/theme';
import 'tinymce/plugins/image';
import 'tinymce/plugins/link';
import 'tinymce/plugins/media';
import 'tinymce/plugins/table';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/contextmenu';
import 'tinymce/plugins/wordcount';
import 'tinymce/plugins/colorpicker';
import 'tinymce/plugins/textcolor';
import 'tinymce/plugins/fullscreen';
import 'tinymce/icons/default';
import { uploadAction } from '@/api/manage';
import { getFileAccessHttpUrl, getVmParentByName } from '@/utils/index';
import axios from 'axios';
import Vue from 'vue';
import { ACCESS_TOKEN } from '@/store/mutation-types';

export default {
    name: 'TinymceEditor',
    components: {
        Editor,
    },
    props: {
        // 富文本值
        value: {
            type: String,
            default: '',
        },

        // 是否禁用
        disabled: {
            type: Boolean,
            default: false,
        },

        // 插件集合
        plugins: {
            type: [ String, Array ],
            // default: 'lists image link media table textcolor wordcount contextmenu fullscreen, kityformula-editor, powerpaste',
            default: 'lists image link media table textcolor wordcount contextmenu fullscreen',
        },

        // 工具栏
        toolbar: {
            type: [ String, Array ],
            default:
                'undo redo |  formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists link unlink image media table | removeformat | fullscreen | fontsizeselect | forecolor backcolor',
            branding: false,
        },

        // 文件上传目录
        bizPath: {
            type: String,
            default: 'editor/temp',
        },

        // 限制上传的图片大小
        isLimitObj: {
            type: Object
        },

        // 限制上传的图片格式
        isLimitFormat: {
            type: String,
            default: ''
        },
        // 区分项目类型
        formType: {
            type: String,
            default: '',
        },

    },
    data() {
        return {
            // 初始化配置
            init: {
                deprecation_warnings: false,// 去除api废弃警告
                language_url: '/tinymce/langs/zh_CN.js',
                language: 'zh_CN',
                skin_url: '/tinymce/skins/lightgray',
                fontsize_formats: '14px 16px 18px 20px 24px 26px 28px 30px 32px 36px', // 字体大小
                height: 300,
                plugins: this.plugins,
                toolbar: this.toolbar,
                branding: false,
                menubar: false,
                toolbar_drawer: false,
                formats: {
                    pre: { block: 'p' },
                },
                default_link_target: '_blank',
                file_picker_types: 'media',
                video_template_callback: function(data) {
                    // <video width=${data.width} height=${data.height} controls="controls" src=${ data.source }></video>
                    return `<video width="100%" height="auto" controls="controls" src=${ data.source }></video>`;
                },
                file_picker_callback: (callback, value, meta) => {
                    let that = this;
                    if (meta.filetype === 'media') {
                        // 模拟上传本地视频
                        let input = document.createElement('input');
                        input.setAttribute('type', 'file');
                        input.setAttribute('accept', '.mp4');
                        input.onchange = function () {
                            let file = this.files[0];
                            let formData = new FormData();
                            formData.append('file', file);
                            formData.append('biz', that.bizPath);
                            // 把上传按钮給隐藏掉
                            that.$nextTick(() => {
                                document.getElementsByClassName('tox-browse-url')[0].style = 'display: none';
                            });
                            // 先销毁前一个的div
                            let body = document.getElementsByClassName('tox-dialog__content-js')[0];
                            if(body.childNodes.length > 1){
                                body.removeChild(body.lastElementChild);
                            }
                            // 先创建一个div
                            let containDiv = document.createElement('div');
                            containDiv.setAttribute('style', 'display: flex; align-items: baseline;');
                            // 创建一个进度条
                            let progerssDiv = document.createElement('progress');
                            // 创建上传进度显示的文字
                            let progerssTotal = document.createElement('span');
                            progerssTotal.innerHTML = '0%';
                            containDiv.appendChild(progerssDiv);
                            containDiv.appendChild(progerssTotal);
                            progerssDiv.setAttribute('style', 'width: 80%;height: 10px;background: red;margin: 0 10px 0 30px;box-sizing: border-box;border-radius:20px');
                            progerssDiv.setAttribute('max', 100);
                            progerssDiv.setAttribute('value', 0);
                            body.setAttribute('style', 'flex-direction: column;');
                            body.appendChild(containDiv);
                            axios({
                                url: `${window._CONFIG['domianURL']}${this.formType==='crm'?'/sideBar/openApi/uploadCrmFile':'/sideBar/openApi/uploadSchoolFile'}`,
                                method: 'post',
                                headers: {
                                    'Content-Type': 'multipart/form-data', // 文件上传
                                    'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)
                                },
                                data: formData,
                                onUploadProgress: progressEvent => {
                                    if(progressEvent.lengthComputable){
                                        progerssDiv.setAttribute('value', progressEvent.loaded / progressEvent.total * 100);
                                        progerssTotal.innerHTML = `${(progressEvent.loaded / progressEvent.total * 100).toFixed(0)}%`;
                                    }
                                },
                            }).then(res => {
                                let path = getFileAccessHttpUrl(res.data.message,'',this.formType);
                                callback(path);
                            });
                        };
                        input.click();
                    }
                },
                urlconverter_callback: function(url, node, on_save, name) {
                    // console.log('图片链接', url );
                    return url;
                },
                // 自定义图片上传
                images_upload_handler: (blobInfo, callback, failure) => {
                    return new Promise((resolve,reject)=>{
                        console.log('自定义图片上传：',blobInfo)
                        // 判断是否要限制上传的格式
                        if(this.isLimitFormat){
                            if(!this.isFileFormat(blobInfo.blob())){
                                failure(`仅支持${this.isLimitFormat}格式的图片`);
                                reject();
                            }
                        }
                        // 判断是否要限制上传的图片大小
                        if(this.isLimitObj){
                            const obj = this.checkImageSize(blobInfo.blob());
                            if(obj && obj.type){
                                failure(obj.text);
                                reject();
                            }
                        }
                        let formData = new FormData();
                        // formData.append('file', blobInfo.blob(), blobInfo.filename());
                        formData.append('file', blobInfo.blob(), blobInfo.filename?blobInfo.filename():blobInfo.file.name);
                        formData.append('biz', this.bizPath);
                        uploadAction(`${window._CONFIG['domianURL']}${this.formType==='crm'?'/sideBar/openApi/uploadCrmFile':'/sideBar/openApi/uploadSchoolFile'}`, formData).then(res => {
                            if (res.message === 'local') {
                                const img = `data:image/jpeg;base64,${blobInfo.base64()}`;
                                callback(img);
                                resolve();
                            }
                            else {
                                let img = getFileAccessHttpUrl(res.message,'',this.formType);
                                callback(img);
                                resolve();
                            }
                        }).catch(err => {
                            failure(err.message);
                            reject();
                        });
                    })
                },
            },
            myValue: this.value,
            reloading: false,
        };
    },

    watch: {
        value(newValue) {
            this.myValue = newValue == null ? '' : newValue;
        },

        myValue(newValue) {
            this.$emit('input', newValue.replace(/..\/..\/..\/sdBusinessOnlineSchool/g, window._CONFIG['domianURL']));
        },
    },

    mounted() {
        this.initATabsChangeAutoReload();
    },

    methods: {
        /**
         * 自动判断父级是否是 <a-tabs/> 组件，然后添加事件监听，自动触发reload()
         *
         * 由于 tabs 组件切换会导致 tinymce 无法输入，
         * 只有重新加载才能使用（无论是vue版的还是jQuery版tinymce都有这个通病）
         */
        initATabsChangeAutoReload() {
            // 获取父级
            let tabs = getVmParentByName(this, 'ATabs');
            let tabPane = getVmParentByName(this, 'ATabPane');
            if (tabs && tabPane) {
                // 用户自定义的 key
                let currentKey = tabPane.$vnode.key;

                // 添加事件监听
                tabs.$on('change', key => {
                    // 切换到自己时执行reload
                    if (currentKey === key) {
                        this.reload();
                    }
                });

                this.reload();
            }
            else {
                let tabLayout = getVmParentByName(this, 'TabLayout');
                tabLayout.excuteCallback(() => {
                    this.reload();
                });
            }
        },

        reload() {
            this.reloading = true;
            this.$nextTick(() => this.reloading = false);
        },

        onClick(e) {
            this.$emit('onClick', e, tinymce);
        },

        // 可以添加一些自己的自定义事件，如清空内容
        clear() {
            this.myValue = '';
        },

        // 获取纯文本
        getPlainText(index = 0) {
            const activeEditor = tinymce.editors[index];
            const editBody = activeEditor.getBody();
            activeEditor.selection.select(editBody);
            let text = activeEditor.selection.getContent({ format: 'text' }) || '';
            // 清除回车换行
            text = text.replace(/[\r\n]/g, '');
            // 去掉空格
            text = text.replace(/[ ]/g, '');
            // 去掉首尾空格
            text = text.trim();
            return text;
        },

        // 判断图片的大小
        checkImageSize(file) {
            if (this.isLimitObj.unit === 'KB') {
                let size = (file.size / 1024).toFixed(2);
                if (!(size <= this.isLimitObj.size)) {
                    this.$message.warning();
                    return {
                        type: true,
                        text: `图片大于${this.isLimitObj.size}KB，请重新上传`
                    };
                }
            }
            else if (this.isLimitObj.unit === 'M') {
                let size = (file.size / 1024 / 1024).toFixed(2);
                if (!(size <= this.isLimitObj.size)) {
                    return {
                        type: true,
                        text: `图片大于${this.isLimitObj.size}M，请重新上传`
                    };
                }
            }
        },

        // 判断图片的格式
        isFileFormat(file){
            return this.isLimitFormat.indexOf(file.name.split('.').pop().toLowerCase()) > -1;
        }
    },
};
</script>

<style scoped lang="less"></style>
